import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, Subscription, throwError, timer } from 'rxjs';
import { catchError, filter, finalize } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material';

const LOADER_DEBOUNCE_TIME: number = 500;

@Injectable()
export class AppInterceptor implements HttpInterceptor {

  constructor(private snackBar: MatSnackBar) { }
  private loadingOverlayElement: HTMLDivElement = document.querySelector('.loading-overlay') as HTMLDivElement;

  intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    const loaderSubscription: Subscription = timer(LOADER_DEBOUNCE_TIME)
      .subscribe(() => {
        if (this.loadingOverlayElement) {
          this.loadingOverlayElement.classList.add('loading');
        }
      });

    return next.handle(req)
      .pipe(
        catchError((error: HttpErrorResponse) => {             // HttpResponseBase
          // if (error instanceof HttpErrorResponse) {
          //   switch ((error as HttpErrorResponse).status) {
          //     // case 401:
          //     //   return this.handleUnauthorised(req, next);
          //     default:
          //       this.snackBar.open(`${error.error.message}`, 'Ok', {
          //         duration: 4000,
          //       });

          //       return throwError(error);
          //   }
          // }
          // if (error.error instanceof ErrorEvent) {
          //   this.snackBar.open(`Error: ${error.error.message}`, 'Ok', {
          //     duration: 4000,
          //   });
          // }
          if (!error.error) {
            this.snackBar.open(`${error.message}`, 'Ok', {
              panelClass: 'red-snackbar',
              verticalPosition: 'top',
              horizontalPosition: 'end',
            });
          } else if (error.error instanceof ProgressEvent) {
            this.snackBar.open(`${error.message}`, 'Ok', {
              panelClass: 'red-snackbar',
              verticalPosition: 'top',
              horizontalPosition: 'end',
            });
          } else {
            this.snackBar.open(`${error.error.error.message}`, 'Ok', {
              panelClass: 'red-snackbar',
              verticalPosition: 'top',
              horizontalPosition: 'end',
            });
          }

          return throwError(error);
        }),
        filter((res: HttpResponse<T>) => res.url && res.url.includes(req.urlWithParams)),
        finalize(() => {
          loaderSubscription.unsubscribe();
          if (this.loadingOverlayElement) {
            this.loadingOverlayElement.classList.remove('loading');
          }
        })
      );
  }

  //   handleUnauthorised<T>(req: HttpRequest<T>, next: HttpHandler): Observable<never> {
  // // TODO: refresh token API
  //
  //     return throwError(req);
  //   }
}
